import { TDropdownOption } from "@/components/shared/Dropdown";

export const PRO_DATA = [
  // '<span class="font-semibold">Unlimited</span> Culling & Editing',
  "Unlimited AI Culling",
  "Unlimited AI Editing",
  `AI Retouching`,
  "Aftershoot Galleries",
  "1 Personal AI Profile",
  "Access to 30+ AI-styles",
  "Crop and Straighten",
];

export const OPTIONS_VAL_EXPERIENCE: TDropdownOption[] = [
  {
    id: "1",
    label: "I'm a hobbyist",
    value: "hobby",
  },
  {
    id: "2",
    label: "1-3 Years",
    value: "1-2",
  },
  {
    id: "3",
    label: "3-5 Years",
    value: "3-5",
  },
  {
    id: "4",
    label: "5-15 Years",
    value: "5-15",
  },
  {
    id: "5",
    label: "More than 15 Years",
    value: "15+",
  },
];

export const OPTIONS_VAL_GENRE: TDropdownOption[] = [
  {
    id: "1",
    label: "Wedding & Engagement",
    value: "wedding and engagement",
  },
  {
    id: "2",
    label: "Portraits & Headshots",
    value: "portraits and headshots",
  },
  {
    id: "3",
    label: "Family",
    value: "family",
  },
  {
    id: "4",
    label: "Sports",
    value: "sports",
  },
  {
    id: "5",
    label: "Boudoir",
    value: "boudoir",
  },
  {
    id: "6",
    label: "Wildlife & Nature",
    value: "wildlife and nature",
  },
  {
    id: "7",
    label: "Pets",
    value: "pets",
  },
];

export const OPTIONS_VAL_USAGE: TDropdownOption[] = [
  {
    id: "1",
    label: "For Culling images",
    value: "culling",
  },
  {
    id: "2",
    label: "For Editing images",
    value: "editing",
  },
  {
    id: "3",
    label: "For both Culling and Editing images",
    value: "culling and editing",
  },
];

export const OPTIONS_VAL_SOURCE: TDropdownOption[] = [
  {
    id: "1",
    label: "Search Engines (e.g., Google)",
    value: "google",
  },
  {
    id: "2",
    label: "Social Media Platforms",
    value: "social media",
  },
  {
    id: "3",
    label: "YouTube",
    value: "youtube",
  },
  {
    id: "4",
    label: "Aftershoot Community",
    value: "aftershoot community",
  },
  {
    id: "5",
    label: "Referral from a Photographer",
    value: "Rreferral from a photographer",
  },
  {
    id: "6",
    label: "Event or Workshop",
    value: "event or workshop",
  },
  {
    id: "7",
    label: "Photography Blogs (e.g., Fstoppers)",
    value: "photography blog",
  },
];
